import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

const FinanceDashboard = () => {
  const [loading, setLoading] = React.useState(true);
  
  // URL деплоя Google Apps Script (заменить на реальный)
  const DASHBOARD_URL = 'https://script.google.com/macros/s/AKfycbyMPPwfnBd1QeVPRg_-dIFk8ZSwdYTdfTY_JLOOl8vB8NBJj2Kqj6xU9s4GW4vQdHFq2A/exec';
  
  return (
    <Box sx={{ 
      width: '100%', 
      height: '100vh',
      bgcolor: '#0a0a0f',
      position: 'relative'
    }}>
      {loading && (
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center'
        }}>
          <CircularProgress sx={{ color: '#4ade80' }} />
          <Typography sx={{ color: '#fff', mt: 2 }}>
            Загрузка дашборда...
          </Typography>
        </Box>
      )}
      
      <iframe
        src={DASHBOARD_URL}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          opacity: loading ? 0 : 1,
          transition: 'opacity 0.3s ease'
        }}
        onLoad={() => setLoading(false)}
        title="Finance Dashboard"
      />
    </Box>
  );
};

export default FinanceDashboard;
